import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export { getPeripheralTypeLabel, PERIPHERAL_TYPE_VALUES } from '../../peripheral-type-i18n'

export interface RequestParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序字段 接入时间：accesss_time，设备ID:peripheral_id，设备类型：peripheral_type，设备名称：peripheral_name，设备状态:peripheral_name，计算机名：computor_name，所属分组：group_name，登记用户名:user_mark */
  sort_key: string
  /** 排序,true-正序，false-倒序 */
  asc: boolean
  /** 查询关键词 */
  search_word: string
  /** 设备状态 1：启动，2：禁用，3：全部（默认） */
  peripheral_status: number
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
  /** 策略id */
  strategy_id?: string
  /** 设备类型筛选，与 /peripheralcontrol/overview/get 的 peripheral_type 一致（如 0 未知、1 U盘、2 便携设备） */
  peripheral_type?: number
}

export interface List {
  /** 接入时间 */
  access_time: number
  /** 设备ID */
  peripheral_id: string
  /** 设备类型 */
  peripheral_type: number
  /** 设备名称 */
  peripheral_name: string
  /** 设备状态 1：启动，2：禁用 */
  peripheral_status: number
  /** 计算机名 */
  computor_name: string
  /** 所属分组 */
  group_name: string
  /** 登记用户名 */
  user_mark: string
  /** 内网ip地址 */
  client_ip: string
  /** 外网ip地址 */
  system_ip: string
  /** 触发策略 */
  strategy_name?: string
}

export interface ResponseData {
  /** 存储设备汇总信息列表 */
  list: List[]
  /** 总数 */
  total: number
}

@Injectable()
export class TimeViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getPeripheralcontrolViewTimeGet (data: RequestParams) {
    return this.http.post<ResponseData>('/peripheralcontrol/view/time/get', data).then(res => ({list:res.list.map(item => ({computer_name:item.computor_name,...item})),resp_common:res.resp_common,total:res.total}))
  }

  @ParamsClean([0], 1)
  download (type: 0 | 1, options: Partial<RequestParams>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 1, // 不分页
      limit: 9999999
    })
    return this.http.downloadWithBlob('/peripheralcontrol/view/time/export', params, moduleName)
  }
}
